import { NgModule } from '@angular/core';

import { MapValuesPipe } from './map-values.pipe';

@NgModule({
  declarations: [
    MapValuesPipe
  ],
  imports: [

  ],
  exports: [
    MapValuesPipe
  ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts